var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g2, _g3, _path10, _path11, _g4, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWebAndDev({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 159,
    viewBox: "0 0 192 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M156.554 30.9059C156.574 29.4731 156.45 28.074 156.192 26.7221L163.238 22.7837L156.851 11.3554L149.828 15.2807C147.747 13.3635 145.268 11.8648 142.531 10.9161L142.642 2.88598L129.55 2.70482L129.439 10.735C128.21 11.1243 127.029 11.6169 125.909 12.213C125.774 12.2826 125.644 12.3611 125.513 12.4352C125.383 12.5093 125.248 12.5789 125.117 12.6574C124.023 13.2986 122.982 14.0431 122.01 14.8869L115.111 10.7733L108.411 22.0205L115.31 26.1341C115.029 27.3892 114.868 28.6594 114.829 29.9268C114.826 30.0785 114.824 30.2347 114.822 30.3865C114.82 30.5338 114.818 30.6811 114.816 30.8329C114.825 32.1009 114.951 33.3751 115.192 34.6419L108.182 38.5629L114.569 49.9912L121.579 46.0702C123.713 48.0284 126.21 49.4916 128.885 50.4126L128.774 58.4561L141.866 58.6373L141.978 50.567C143.291 50.1476 144.58 49.594 145.831 48.8925C147.109 48.178 148.286 47.346 149.348 46.4187L156.304 50.5643L163.005 39.3171L156.049 35.1715C156.353 33.7962 156.529 32.3655 156.55 30.9014L156.554 30.9059ZM144.156 39.9626C144.097 40.0153 144.043 40.0637 143.984 40.1165C143.753 40.3186 143.519 40.5074 143.279 40.6916C143.167 40.7748 143.054 40.8581 142.937 40.9413C142.738 41.0814 142.54 41.2126 142.333 41.3392C142.171 41.4397 142.004 41.5356 141.838 41.6315C141.671 41.7274 141.5 41.8143 141.33 41.9013C141.114 42.0099 140.894 42.1095 140.674 42.2047C140.543 42.2609 140.413 42.3127 140.283 42.3645C140 42.4722 139.717 42.5754 139.426 42.6651C139.354 42.6865 139.278 42.7122 139.206 42.7335C138.045 43.0657 136.815 43.2451 135.543 43.2275C128.58 43.1312 123.011 37.4065 123.108 30.4431C123.131 28.738 123.497 27.118 124.129 25.6445C124.162 25.5735 124.189 25.5069 124.222 25.4359C124.337 25.1786 124.47 24.9259 124.603 24.6733C124.69 24.5138 124.777 24.3587 124.868 24.2037C124.96 24.0487 125.055 23.8983 125.156 23.7479C125.311 23.5134 125.47 23.279 125.643 23.0537C125.689 22.9918 125.734 22.9344 125.779 22.8725C126.775 21.6139 128.026 20.5196 129.516 19.6874C135.594 16.2892 143.275 18.4626 146.673 24.5412C147.291 25.6525 147.726 26.8148 147.982 27.997C147.999 28.0731 148.011 28.1447 148.028 28.2209C148.087 28.5208 148.136 28.8206 148.172 29.1202C148.188 29.2588 148.204 29.4019 148.215 29.5405C148.239 29.7819 148.253 30.0232 148.259 30.2643C148.265 30.4564 148.267 30.6484 148.264 30.8359C148.262 31.0278 148.259 31.2198 148.243 31.4115C148.226 31.6524 148.21 31.8887 148.179 32.1294C148.164 32.2721 148.144 32.4102 148.124 32.5528C148.08 32.8513 148.022 33.1496 147.956 33.4434C147.937 33.519 147.923 33.5947 147.904 33.6703C147.611 34.8449 147.148 35.9948 146.499 37.0886C145.85 38.1823 145.056 39.1357 144.16 39.9492L144.156 39.9626Z",
    fill: "#EBEBF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.101 71.2014C187.112 70.3935 187.043 69.6068 186.897 68.8413L190.87 66.6194L187.267 60.1763L183.307 62.3895C182.135 61.3062 180.736 60.4654 179.194 59.9307L179.257 55.4045L171.878 55.3024L171.815 59.8286C171.125 60.0467 170.456 60.3276 169.826 60.6627C169.75 60.7018 169.678 60.7455 169.601 60.7846C169.529 60.8282 169.453 60.8673 169.381 60.911C168.764 61.273 168.178 61.6935 167.627 62.168L163.739 59.8507L159.959 66.1916L163.847 68.509C163.69 69.2166 163.599 69.9342 163.576 70.6482C163.575 70.733 163.574 70.8223 163.572 70.9071C163.571 70.9919 163.57 71.0722 163.569 71.157C163.572 71.8714 163.643 72.5912 163.78 73.303L159.83 75.5118L163.433 81.9549L167.383 79.746C168.587 80.8476 169.995 81.6751 171.502 82.1915L171.439 86.7266L178.817 86.8287L178.88 82.2802C179.62 82.0449 180.348 81.7291 181.05 81.337C181.77 80.9317 182.432 80.4632 183.033 79.9447L186.952 82.2803L190.732 75.9394L186.813 73.6038C186.985 72.8294 187.085 72.0227 187.096 71.1969L187.101 71.2014ZM180.11 76.3059C180.079 76.3367 180.047 76.363 180.011 76.3938C179.884 76.5081 179.749 76.6134 179.613 76.7187C179.55 76.7669 179.487 76.8151 179.42 76.8588C179.307 76.9376 179.194 77.012 179.082 77.0818C178.992 77.1386 178.897 77.1954 178.802 77.2476C178.708 77.2999 178.614 77.3522 178.515 77.3999C178.393 77.4607 178.272 77.5171 178.146 77.5734C178.074 77.6036 177.998 77.6338 177.926 77.6641C177.769 77.7244 177.607 77.7847 177.442 77.8315C177.401 77.8444 177.361 77.8572 177.316 77.87C176.662 78.0573 175.968 78.1594 175.25 78.1494C171.326 78.0951 168.187 74.8685 168.242 70.9449C168.255 69.9852 168.46 69.0728 168.819 68.2385C168.838 68.1985 168.852 68.1585 168.87 68.1231C168.935 67.9766 169.008 67.8348 169.086 67.693C169.136 67.6044 169.182 67.5158 169.237 67.4272C169.287 67.3386 169.342 67.2546 169.397 67.1705C169.483 67.0378 169.575 66.9051 169.67 66.7769C169.697 66.7416 169.72 66.7107 169.747 66.6753C170.311 65.9643 171.016 65.349 171.853 64.8829C175.281 62.966 179.608 64.1911 181.525 67.6196C181.874 68.245 182.119 68.9002 182.266 69.5675C182.274 69.6077 182.283 69.6525 182.291 69.6928C182.324 69.8629 182.349 70.0284 182.373 70.1984C182.381 70.2789 182.389 70.3549 182.397 70.4354C182.408 70.5695 182.415 70.708 182.423 70.842C182.426 70.9492 182.429 71.0564 182.427 71.1635C182.426 71.2706 182.424 71.3822 182.414 71.4892C182.407 71.6231 182.392 71.7613 182.377 71.895C182.367 71.9752 182.357 72.0555 182.347 72.1312C182.322 72.3005 182.288 72.4652 182.25 72.6344C182.241 72.6789 182.231 72.7189 182.222 72.7634C182.056 73.4264 181.797 74.0746 181.432 74.6901C181.066 75.3056 180.617 75.8441 180.115 76.3059L180.11 76.3059Z",
    fill: "#EBEBF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9608 113.008C42.569 111.958 42.0827 110.969 41.5106 110.051L45.547 105.173L37.6372 98.6259L33.6144 103.486C31.5496 102.671 29.3139 102.279 27.0447 102.363L24.8495 96.4578L15.2236 100.035L17.4188 105.94C16.6287 106.572 15.9093 107.268 15.2559 108.022C15.1788 108.11 15.1061 108.203 15.0289 108.296C14.9517 108.388 14.8746 108.477 14.8019 108.569C14.184 109.347 13.6321 110.187 13.1599 111.083L6.95092 110.028L5.23484 120.152L11.4438 121.207C11.5952 122.204 11.8362 123.181 12.167 124.119C12.2056 124.231 12.2487 124.343 12.2917 124.46C12.3304 124.567 12.369 124.68 12.4122 124.787C12.7789 125.712 13.2308 126.607 13.768 127.467L9.7498 132.318L17.6596 138.865L21.6779 134.014C23.7916 134.838 26.0322 135.204 28.2523 135.119L30.4473 141.033L40.0732 137.456L37.8695 131.524C38.7093 130.843 39.4968 130.073 40.2142 129.208C40.9452 128.321 41.5699 127.383 42.0879 126.403L48.3459 127.463L50.062 117.339L43.804 116.279C43.6405 115.188 43.361 114.094 42.9607 113.013L42.9608 113.008ZM36.4586 123.142C36.4311 123.195 36.4036 123.249 36.376 123.302C36.2659 123.515 36.147 123.718 36.0237 123.922C35.9644 124.015 35.905 124.108 35.8412 124.201C35.7364 124.36 35.6271 124.51 35.5134 124.665C35.4224 124.784 35.3315 124.904 35.2317 125.018C35.1363 125.133 35.0365 125.248 34.9368 125.358C34.8098 125.499 34.6785 125.636 34.5427 125.768C34.4657 125.847 34.3843 125.922 34.3029 125.996C34.1266 126.155 33.9458 126.313 33.7608 126.458C33.7156 126.497 33.666 126.532 33.6164 126.567C32.8629 127.142 32.0125 127.617 31.0746 127.965C25.9542 129.868 20.2624 127.258 18.3599 122.137C17.895 120.885 17.703 119.597 17.7472 118.338C17.748 118.28 17.7488 118.222 17.7542 118.16C17.7662 117.937 17.7871 117.718 17.8169 117.496C17.8367 117.357 17.8521 117.215 17.8763 117.077C17.9005 116.939 17.9292 116.801 17.9579 116.663C18.0056 116.445 18.0577 116.231 18.1187 116.018C18.1329 115.96 18.1515 115.902 18.1701 115.849C18.5395 114.644 19.1447 113.491 19.9983 112.463C23.4808 108.256 29.7125 107.669 33.919 111.151C34.6871 111.787 35.3332 112.519 35.858 113.307C35.8931 113.357 35.9236 113.407 35.9541 113.461C36.0808 113.663 36.203 113.87 36.3162 114.077C36.3684 114.176 36.4206 114.271 36.4683 114.374C36.5508 114.545 36.6332 114.716 36.7067 114.891C36.7628 115.03 36.8189 115.169 36.8706 115.308C36.9222 115.452 36.9738 115.591 37.021 115.734C37.0765 115.914 37.1321 116.093 37.1786 116.277C37.2084 116.384 37.2337 116.492 37.259 116.599C37.3094 116.832 37.3552 117.065 37.3877 117.298C37.3959 117.356 37.4039 117.418 37.412 117.477C37.533 118.416 37.5195 119.389 37.3541 120.373C37.1887 121.358 36.8768 122.282 36.4543 123.129L36.4586 123.142Z",
    fill: "#EBEBF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.0842 25.2511L4.82397 24.0159C4.19459 24.0072 3.68837 23.4868 3.69708 22.8574C3.70579 22.228 4.22621 21.7218 4.85559 21.7305L94.1158 22.9657C94.7452 22.9744 95.2514 23.4948 95.2427 24.1242C95.234 24.7536 94.7136 25.2598 94.0842 25.2511Z",
    fill: "#EBEBF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.9709 33.4375L4.71069 32.2023C4.08131 32.1936 3.57509 31.6732 3.5838 31.0438C3.59251 30.4144 4.11293 29.9082 4.74231 29.9169L94.0025 31.1521C94.6319 31.1608 95.1381 31.6812 95.1294 32.3106C95.1207 32.9399 94.6003 33.4462 93.9709 33.4375Z",
    fill: "#EBEBF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8576 41.6238L4.59741 40.3887C3.96803 40.38 3.46181 39.8596 3.47052 39.2302C3.47922 38.6008 3.99965 38.0946 4.62903 38.1033L93.8892 39.3384C94.5186 39.3471 95.0248 39.8676 95.0161 40.497C95.0074 41.1263 94.487 41.6325 93.8576 41.6238Z",
    fill: "#EBEBF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.776 47.5204L4.51575 46.2852C3.88465 46.2765 3.36597 46.781 3.35723 47.4121C3.3485 48.0432 3.85303 48.5619 4.48413 48.5706L93.7443 49.8058C94.3754 49.8145 94.8941 49.31 94.9028 48.6789C94.9116 48.0478 94.4071 47.5291 93.776 47.5204Z",
    fill: "#EBEBF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.6311 57.9922L4.37084 56.757C3.74146 56.7483 3.23524 56.2279 3.24395 55.5985C3.25266 54.9691 3.77309 54.4629 4.40247 54.4716L93.6627 55.7068C94.2921 55.7155 94.7983 56.2359 94.7896 56.8653C94.7809 57.4947 94.2604 58.0009 93.6311 57.9922Z",
    fill: "#EBEBF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.5178 66.1786L4.25756 64.9434C3.62818 64.9347 3.12196 64.4143 3.13067 63.7849C3.13938 63.1555 3.65981 62.6493 4.28919 62.658L93.5494 63.8931C94.1788 63.9019 94.685 64.4223 94.6763 65.0517C94.6676 65.681 94.1472 66.1873 93.5178 66.1786Z",
    fill: "#EBEBF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.4045 74.3605L4.14428 73.1253C3.5149 73.1166 3.00868 72.5962 3.01739 71.9668C3.0261 71.3374 3.54653 70.8312 4.17591 70.8399L93.4361 72.0751C94.0655 72.0838 94.5717 72.6042 94.563 73.2336C94.5543 73.863 94.0339 74.3692 93.4045 74.3605Z",
    fill: "#EBEBF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2912 82.5469L4.031 81.3117C3.40162 81.303 2.8954 80.7826 2.90411 80.1532C2.91282 79.5238 3.43325 79.0176 4.06262 79.0263L93.3228 80.2615C93.9522 80.2702 94.4584 80.7906 94.4497 81.42C94.441 82.0494 93.9206 82.5556 93.2912 82.5469Z",
    fill: "#EBEBF2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.1779 90.7333L3.91772 89.4981C3.28834 89.4894 2.78212 88.969 2.79083 88.3396C2.79954 87.7102 3.31996 87.204 3.94934 87.2127L93.2096 88.4478C93.8389 88.4566 94.3452 88.977 94.3364 89.6064C94.3277 90.2357 93.8073 90.742 93.1779 90.7333Z",
    fill: "#EBEBF2"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M92.6615 149.042C130.515 149.566 161.241 147.093 161.291 143.518C161.34 139.943 130.694 136.621 92.8406 136.097C54.9871 135.573 24.2607 138.047 24.2112 141.621C24.1618 145.196 54.808 148.518 92.6615 149.042Z",
    fill: "#EBEBF2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.61 143.188L72.8828 142.638L79.9892 123.039L106.048 123.4L112.61 143.188Z",
    fill: "url(#paint0_linear_459_509)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2002 62.4138L157.495 64.1753L156.623 127.211C156.571 130.983 153.467 133.998 149.699 133.946L36.0629 132.374C32.291 132.322 29.2758 129.217 29.3279 125.45L30.2002 62.4138Z",
    fill: "url(#paint1_linear_459_509)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3006 42.9262L150.933 44.4986C154.704 44.5507 157.72 47.6551 157.667 51.4225L156.748 117.878L29.4571 116.116L30.3767 49.6611C30.4289 45.8893 33.5333 42.874 37.3006 42.9262Z",
    fill: "#3D3D89"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M152.774 51.4262L35.4956 49.8034L34.6743 109.157L151.953 110.78L152.774 51.4262Z",
    fill: "url(#paint2_linear_459_509)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M92.9534 127.947C94.9995 127.975 96.6812 126.339 96.7095 124.293C96.7378 122.247 95.1021 120.565 93.0559 120.537C91.0098 120.508 89.3281 122.144 89.2998 124.19C89.2715 126.237 90.9073 127.918 92.9534 127.947Z",
    fill: "url(#paint3_linear_459_509)"
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M122.956 143.331L62.5361 142.495C62.5641 140.469 64.2295 138.844 66.2605 138.872L119.338 139.607C121.365 139.635 122.989 141.3 122.961 143.331L122.956 143.331Z",
    fill: "url(#paint4_linear_459_509)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M149.727 158.073C165.066 158.285 177.525 156.679 177.555 154.485C177.585 152.291 165.176 150.34 149.837 150.128C134.498 149.915 122.039 151.522 122.009 153.716C121.979 155.91 134.388 157.861 149.727 158.073Z",
    fill: "#EBEBF2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M164.547 91.4396L136.756 91.055C134.565 91.0247 132.764 92.7767 132.733 94.9683L131.995 148.349C131.964 150.541 133.716 152.342 135.908 152.373L163.699 152.757C165.89 152.787 167.691 151.035 167.722 148.844L168.46 95.4627C168.491 93.2711 166.739 91.4699 164.547 91.4396Z",
    fill: "#4B4BA0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M168.456 95.7662L132.729 95.2718L132.002 147.8L167.729 148.295L168.456 95.7662Z",
    fill: "url(#paint5_linear_459_509)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_459_509)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.297 109.167L141.51 108.921C139.318 108.891 137.517 110.643 137.487 112.834L137.24 130.622C137.21 132.814 138.962 134.615 141.154 134.645L158.942 134.891C161.133 134.922 162.934 133.169 162.965 130.978L163.211 113.19C163.241 110.999 161.489 109.197 159.297 109.167Z",
    fill: "url(#paint6_linear_459_509)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_459_509)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.091 131.755C144.664 131.68 140.306 127.2 140.381 121.772C140.456 116.344 144.936 111.986 150.364 112.061C155.792 112.137 160.15 116.617 160.075 122.045C159.999 127.472 155.519 131.83 150.091 131.755ZM150.339 113.878C145.911 113.817 142.263 117.369 142.202 121.797C142.141 126.225 145.693 129.873 150.117 129.934C154.54 129.995 158.192 126.443 158.253 122.019C158.315 117.596 154.762 113.939 150.339 113.878Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.462 125.639L146.062 122.561L147.527 120.942L149.304 122.552L152.781 118.68L154.404 120.14L149.462 125.639Z",
    fill: "white"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M155.041 97.6611L146.087 97.5372C144.708 97.5181 143.603 96.3822 143.622 95.0029L157.576 95.196C157.556 96.5753 156.421 97.6801 155.041 97.6611Z",
    fill: "#4B4BA0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M153.82 95.5637L147.356 95.4742C147.124 95.471 146.944 95.281 146.947 95.0534C146.95 94.8213 147.14 94.6409 147.368 94.644L153.831 94.7334C154.059 94.7366 154.244 94.9267 154.241 95.1543C154.237 95.3864 154.047 95.5668 153.82 95.5637Z",
    fill: "white"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_459_509)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M125.152 37.9361L54.9072 36.9641C52.7156 36.9338 50.9144 38.6858 50.8841 40.8774L50.2963 83.3493C50.266 85.5409 52.0181 87.3421 54.2096 87.3724L124.455 88.3445C126.646 88.3748 128.447 86.6227 128.478 84.4311L129.065 41.9592C129.096 39.7677 127.344 37.9664 125.152 37.9361Z",
    fill: "url(#paint7_linear_459_509)"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M125.093 41.8998L54.8477 40.9278L54.2599 83.3997L124.505 84.3717L125.093 41.8998Z",
    fill: "#3D3D89"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M69.5663 46.8103L62.2593 46.7092L62.2456 47.6957L69.5527 47.7968L69.5663 46.8103Z",
    fill: "#FFC700"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M86.8317 47.0492L71.8784 46.8423L71.8648 47.8288L86.8181 48.0357L86.8317 47.0492Z",
    fill: "#FFC700"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6132 50.8527L65.3062 50.7516L65.2925 51.7381L72.5996 51.8392L72.6132 50.8527Z",
    fill: "white"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M117.652 51.4759L74.9253 50.8847L74.9116 51.8712L117.638 52.4624L117.652 51.4759Z",
    fill: "#1E9AFF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5619 54.562L65.2549 54.4609L65.2412 55.4474L72.5483 55.5485L72.5619 54.562Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M117.6 55.1853L74.874 54.594L74.8604 55.5805L117.587 56.1717L117.6 55.1853Z",
    fill: "#1E9AFF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5102 58.2758L65.2031 58.1747L65.1895 59.1612L72.4965 59.2623L72.5102 58.2758Z",
    fill: "white"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M117.549 58.899L74.8223 58.3078L74.8086 59.2943L117.535 59.8855L117.549 58.899Z",
    fill: "#1E9AFF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4589 61.9896L65.1519 61.8885L65.1382 62.875L72.4453 62.9761L72.4589 61.9896Z",
    fill: "white"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3022 65.8747L61.9951 65.7736L61.9815 66.7601L69.2885 66.8612L69.3022 65.8747Z",
    fill: "#FFC700"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5676 66.1136L71.6143 65.9067L71.6006 66.8932L86.5539 67.1001L86.5676 66.1136Z",
    fill: "#FFC700"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M102.211 70.3303L74.6616 69.9491L74.648 70.9356L102.198 71.3168L102.211 70.3303Z",
    fill: "white"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M102.16 74.0396L74.6099 73.6584L74.5962 74.6449L102.146 75.0261L102.16 74.0396Z",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2978 73.6264L69.874 73.5929L69.8604 74.5793L72.2842 74.6129L72.2978 73.6264Z",
    fill: "#1E9AFF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2465 77.3402L64.9395 77.2391L64.9258 78.2256L72.2329 78.3267L72.2465 77.3402Z",
    fill: "#1E9AFF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M102.108 77.7534L74.5586 77.3722L74.5449 78.3587L102.095 78.7399L102.108 77.7534Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M117.7 70.5446L104.198 70.3578L104.184 71.3443L117.687 71.5311L117.7 70.5446Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M117.649 74.254L104.146 74.0671L104.132 75.0536L117.635 75.2404L117.649 74.254Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M117.597 77.9677L104.095 77.7809L104.081 78.7674L117.584 78.9542L117.597 77.9677Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M117.497 62.6128L74.771 62.0216L74.7573 63.0081L117.484 63.5993L117.497 62.6128Z",
    fill: "#1E9AFF"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_459_509)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.916 56.5694L15.2807 56.2562C13.0891 56.2258 11.2879 57.9779 11.2576 60.1695L10.9444 82.8048C10.914 84.9964 12.6661 86.7976 14.8577 86.8279L37.493 87.1411C39.6846 87.1714 41.4858 85.4194 41.5161 83.2278L41.8293 60.5925C41.8597 58.4009 40.1076 56.5997 37.916 56.5694Z",
    fill: "url(#paint8_linear_459_509)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_459_509)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.4289 71.776C33.4356 71.2939 33.393 70.8201 33.3056 70.3635L35.6857 69.0303L33.5248 65.1698L31.1491 66.4986C30.4437 65.8504 29.607 65.3433 28.6828 65.0224L28.7203 62.3085L24.2968 62.2473L24.2593 64.9612C23.8422 65.0939 23.4471 65.258 23.0692 65.4627C23.0243 65.4844 22.9793 65.5105 22.9343 65.5367C22.8893 65.5628 22.8443 65.5845 22.7993 65.6107C22.4302 65.8288 22.0785 66.0784 21.7486 66.3641L19.4151 64.9746L17.1481 68.7738L19.4817 70.1633C19.3865 70.5861 19.3314 71.0184 19.3166 71.4468C19.3158 71.5003 19.3152 71.5494 19.3144 71.603C19.3137 71.6521 19.3131 71.7012 19.3123 71.7548C19.3153 72.1834 19.3585 72.6126 19.4418 73.0423L17.0707 74.3667L19.2317 78.2272L21.6028 76.9028C22.3258 77.5646 23.1673 78.0585 24.0737 78.3701L24.0361 81.0885L28.4596 81.1497L28.4974 78.4224C28.9413 78.2812 29.377 78.0908 29.7999 77.8556C30.2319 77.6115 30.6286 77.3313 30.9901 77.0193L33.3414 78.418L35.6084 74.6188L33.2571 73.2201C33.3618 72.7528 33.4176 72.2714 33.4244 71.7759L33.4289 71.776ZM29.2389 74.8387C29.2389 74.8387 29.1983 74.8739 29.1802 74.8915C29.1034 74.9574 29.0221 75.0232 28.9409 75.0846C28.9047 75.1154 28.8642 75.1416 28.8237 75.1678C28.756 75.216 28.6884 75.2597 28.6209 75.3034C28.5668 75.3384 28.5084 75.3688 28.4543 75.4038C28.3958 75.4342 28.3418 75.4647 28.2834 75.4952C28.2115 75.5299 28.1351 75.5646 28.0632 75.5993C28.0183 75.6165 27.9733 75.6382 27.9329 75.6555C27.8386 75.6944 27.7399 75.7287 27.6413 75.7586C27.6144 75.7672 27.592 75.7758 27.5651 75.7799C27.1706 75.895 26.7591 75.9518 26.3261 75.9458C23.9738 75.9132 22.0897 73.9808 22.1223 71.624C22.1303 71.0482 22.2539 70.5008 22.4662 70.0037C22.4754 69.9815 22.4847 69.9593 22.4984 69.9327C22.5398 69.844 22.5812 69.7597 22.627 69.6755C22.6545 69.6223 22.6865 69.5692 22.7185 69.5161C22.7505 69.4629 22.7824 69.4143 22.8144 69.3611C22.8691 69.2815 22.9193 69.2019 22.9783 69.1268C22.992 69.1046 23.0101 69.087 23.0238 69.0649C23.3601 68.641 23.7849 68.2718 24.2843 67.9885C26.3406 66.8383 28.9332 67.5752 30.0834 69.6269C30.2926 70.0004 30.4389 70.3953 30.5271 70.7938C30.5312 70.8207 30.5354 70.843 30.5439 70.8699C30.5648 70.9729 30.5813 71.0714 30.5933 71.1742C30.5971 71.2234 30.6054 71.2681 30.6092 71.3173C30.617 71.3978 30.6203 71.4782 30.6236 71.5631C30.6228 71.6255 30.6218 71.6925 30.621 71.755C30.6201 71.8219 30.6192 71.8844 30.6183 71.9514C30.6171 72.0317 30.6071 72.112 30.5971 72.1922C30.5919 72.2412 30.5868 72.2858 30.5772 72.3348C30.5624 72.4373 30.5432 72.5352 30.5195 72.6376C30.5146 72.6643 30.5099 72.6865 30.5006 72.7132C30.4013 73.1092 30.2441 73.4999 30.0248 73.8674C29.8054 74.2349 29.5374 74.5616 29.2345 74.8342L29.2389 74.8387Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_459_509)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.6996 94.5885L42.1323 94.1655C39.9407 94.1352 38.1395 95.8872 38.1092 98.0788L37.8508 116.746C37.8205 118.938 39.5726 120.739 41.7641 120.769L72.3314 121.192C74.523 121.222 76.3242 119.47 76.3546 117.279L76.6129 98.6116C76.6432 96.42 74.8911 94.6188 72.6996 94.5885Z",
    fill: "url(#paint9_linear_459_509)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_459_509)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.748 101.33L44.4166 107.501L51.5744 113.878L51.6214 110.476L48.3447 107.556L51.701 104.727L51.748 101.33Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.716 114.032L70.0474 107.856L62.8896 101.484L62.8426 104.881L66.1194 107.802L62.7631 110.63L62.716 114.032Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4159 115.989L53.3449 115.947L58.0478 99.3682L61.1144 99.4106L56.4159 115.989Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_d_459_509)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.676 22.8714L142.14 22.3935C139.948 22.3632 138.147 24.1152 138.117 26.3068L137.639 60.8423C137.609 63.0339 139.361 64.8351 141.552 64.8654L176.088 65.3433C178.279 65.3736 180.081 63.6216 180.111 61.43L180.589 26.8945C180.619 24.7029 178.867 22.9017 176.676 22.8714Z",
    fill: "url(#paint10_linear_459_509)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_d_459_509)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.746 36.178C168.871 36.1659 168.038 36.3508 167.292 36.6888C166.325 33.0412 163.032 30.3303 159.072 30.2756C155.113 30.2208 151.854 32.7562 150.73 36.2855C150.099 36.0357 149.418 35.8968 148.704 35.8869C145.526 35.8429 142.915 38.3828 142.871 41.5609L175.42 42.0113C175.464 38.8332 172.924 36.222 169.746 36.178Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.021 51.385L158.924 57.4536L164.993 51.5506L160.962 51.4949L161.06 44.4333L157.154 44.3793L157.056 51.4408L153.021 51.385Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d_459_509)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.4351 19.0343L15.7998 18.7211C13.6082 18.6907 11.807 20.4428 11.7766 22.6344L11.4634 45.2697C11.4331 47.4613 13.1851 49.2625 15.3767 49.2928L38.012 49.606C40.2036 49.6364 42.0048 47.8843 42.0352 45.6927L42.3484 23.0574C42.3787 20.8658 40.6267 19.0646 38.4351 19.0343Z",
    fill: "url(#paint11_linear_459_509)"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7426 22.6503L15.3931 22.3272L15.07 45.6768L38.4195 45.9999L38.7426 22.6503Z",
    fill: "#3D3D89"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4224 26.96L19.2754 26.9303L19.2617 27.9168L21.4088 27.9465L21.4224 26.96Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5369 27.1277L22.5518 26.9757L22.5381 27.9621L33.5232 28.1141L33.5369 27.1277Z",
    fill: "#1E9AFF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5688 30.2886L19.23 30.2424L19.2163 31.2288L22.5552 31.275L22.5688 30.2886Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6785 30.4561L23.6934 30.3041L23.6797 31.2906L34.6648 31.4426L34.6785 30.4561Z",
    fill: "#1E9AFF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2906 36.5078L19.1436 36.4781L19.1299 37.4646L21.2769 37.4943L21.2906 36.5078Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M33.405 36.6755L22.4199 36.5235L22.4063 37.5099L33.3914 37.6619L33.405 36.6755Z",
    fill: "#1E9AFF"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4365 39.8408L19.0977 39.7946L19.084 40.7811L22.4228 40.8273L22.4365 39.8408Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5462 40.0084L23.561 39.8564L23.5474 40.8429L34.5325 40.9949L34.5462 40.0084Z",
    fill: "#1E9AFF"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M20.541 33.5777L17.2021 33.5315L17.1885 34.5179L20.5273 34.5641L20.541 33.5777Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6189 33.8001L21.6655 33.5932L21.6519 34.5797L36.6052 34.7866L36.6189 33.8001Z",
    fill: "#1E9AFF"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M103.207 94.1758L94.2529 94.0519L94.129 103.006L103.083 103.13L103.207 94.1758Z",
    fill: "#A7C8FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M116.219 94.3558L107.265 94.2319L107.141 103.186L116.095 103.31L116.219 94.3558Z",
    fill: "#A7C8FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M129.226 94.5358L120.272 94.4119L120.148 103.366L129.102 103.49L129.226 94.5358Z",
    fill: "#A7C8FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M147.395 70.46L133.892 70.2731L133.878 71.2596L147.381 71.4465L147.395 70.46Z",
    fill: "#A7C8FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M147.343 74.1738L133.841 73.9869L133.827 74.9734L147.33 75.1603L147.343 74.1738Z",
    fill: "#A7C8FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M147.292 77.8831L133.79 77.6962L133.776 78.6827L147.279 78.8696L147.292 77.8831Z",
    fill: "#A7C8FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_459_509",
    x: 126.58,
    y: 107.151,
    width: 47.2907,
    height: 47.2911,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.89
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.33
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0666667 0 0 0 0 0.447059 0 0 0 0 0.835294 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_459_509"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_459_509",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_459_509",
    x: 132.88,
    y: 108.31,
    width: 34.6958,
    height: 34.6957,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.75
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.75
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.521569 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_459_509"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_459_509",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_459_509",
    x: 39.6359,
    y: 35.1937,
    width: 100.09,
    height: 72.7011,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.89
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.33
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.521569 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_459_509"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_459_509",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_459_509",
    x: 0.283848,
    y: 54.4858,
    width: 52.2057,
    height: 52.2057,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.89
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.33
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.521569 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_459_509"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_459_509",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_459_509",
    x: 9.5708,
    y: 58.4973,
    width: 33.6147,
    height: 33.9024,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.75
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.75
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.521569 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_459_509"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_459_509",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_459_509",
    x: 27.1906,
    y: 92.3951,
    width: 60.0827,
    height: 48.3473,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.89
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.33
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.521569 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_459_509"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_459_509",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_459_509",
    x: 36.9165,
    y: 95.6182,
    width: 40.6309,
    height: 31.6212,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.75
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.75
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.521569 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_459_509"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_459_509",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_d_459_509",
    x: 126.979,
    y: 20.6231,
    width: 64.2707,
    height: 64.2706,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.89
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.33
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.521569 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_459_509"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_459_509",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_d_459_509",
    x: 135.371,
    y: 26.5247,
    width: 47.5498,
    height: 42.1789,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.75
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.75
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.521569 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_459_509"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_459_509",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_459_509",
    x: 0.802891,
    y: 16.9507,
    width: 52.2057,
    height: 52.2057,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.89
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.33
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.117647 0 0 0 0 0.521569 0 0 0 0 1 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_459_509"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_459_509",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_459_509",
    x1: 79.8715,
    y1: 123.154,
    x2: 105.799,
    y2: 149.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#A7C8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#AACAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#B6D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#CAE0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_459_509",
    x1: 45.7677,
    y1: 47.2713,
    x2: 141.016,
    y2: 145.188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8E9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A7C8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_459_509",
    x1: 50.1762,
    y1: 35.5191,
    x2: 137.272,
    y2: 125.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#562BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7DA5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_459_509",
    x1: 90.4207,
    y1: 121.585,
    x2: 95.5886,
    y2: 126.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7C8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_459_509",
    x1: 77.4865,
    y1: 126.456,
    x2: 108.027,
    y2: 157.853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A7C8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#73ABFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_459_509",
    x1: 128.466,
    y1: 99.414,
    x2: 171.988,
    y2: 144.153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#562BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7DA5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_459_509",
    x1: 138.686,
    y1: 110.043,
    x2: 161.765,
    y2: 133.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35FFFF",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35E6BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_459_509",
    x1: 59.1206,
    y1: 31.2364,
    x2: 120.237,
    y2: 94.0677,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35C9E2",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35E6BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_459_509",
    x1: 12.457,
    y1: 57.3779,
    x2: 40.3123,
    y2: 86.0149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35C9E2",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35E6BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_459_509",
    x1: 42.327,
    y1: 92.3556,
    x2: 72.1367,
    y2: 123.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35C9E2",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35E6BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_459_509",
    x1: 139.316,
    y1: 23.5152,
    x2: 178.912,
    y2: 64.2216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35C9E2",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35E6BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_459_509",
    x1: 12.976,
    y1: 19.8472,
    x2: 40.8313,
    y2: 48.4843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35C9E2",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#35E6BB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebAndDev);
export default __webpack_public_path__ + "static/media/web-and_dev.53bd906f5b103d6ef0f03498c45b2536.svg";
export { ForwardRef as ReactComponent };